@if (formStep1) {
  <div class="modal-content" *let="isGeneratingClauseList$ | async as generatingClausesList">
    <div class="modal-header">
      <h5 class="modal-title pull-left">{{ title }}</h5>
      <mat-icon
        (click)="onCancel()"
        svgIcon="close"
        [ngClass]="{ disabled: !!generatingClausesList }"
      ></mat-icon>
    </div>

    @if (currentStep === DocCreateModalSteps.Step1) {
      <div class="modal-body" [formGroup]="formStep1">
        <div class="row">
          <div class="col">
            <h6 class="sub-title">{{ 'titles.fromPlaybook' | transloco }}</h6>
          </div>
        </div>

        <div class="row mt-10p">
          <div class="col">
            <strong>{{ 'titles.playbook' | transloco }}</strong>
          </div>
        </div>

        <div class="row mt-10p">
          <div class="col-sm-4 col-md-3 control-label">
            {{ 'labels.docType' | transloco }}
          </div>
          <div class="col d-flex">
            <app-single-select-autocomplete
              class="w100"
              formControlName="documentType"
              [autocompleteOptions]="docTypeItems"
            ></app-single-select-autocomplete>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4 col-md-3 control-label">
            {{ 'labels.docLanguage' | transloco }}
          </div>
          <div class="col">
            <app-single-select-autocomplete
              class="w100"
              formControlName="languageId"
              [autocompleteOptions]="contentLanguages"
              optionLabel="displayName"
            ></app-single-select-autocomplete>
          </div>
        </div>

        <div class="row">
          <div class="col-sm-4 col-md-3 control-label">
            {{ 'labels.myPosition' | transloco }}
          </div>
          <div class="col">
            <app-radio formControlName="myPosition" [items]="positionItems"></app-radio>
          </div>
        </div>
      </div>
    }

    @if (noClausesFound) {
      <div class="warning-box">
        <div class="left-side">
          <mat-icon>warning</mat-icon>
        </div>
        <div class="right-side">
          <div class="title">
            {{
              'text.noClausesFound'
                | transloco
                  : {
                      type: docTypeNameTranslated,
                      language: languageTranslated,
                      position: positionTranslated
                    }
            }}
          </div>
          <div>{{ 'text.noClausesFoundExtra' | transloco }}</div>
        </div>
      </div>
    }

    @if (currentStep === DocCreateModalSteps.Step2) {
      <div class="modal-body" [formGroup]="formStep1">
        <div class="row">
          <div class="col">
            <h6 class="sub-title">{{ 'titles.clausesToInclude' | transloco }}</h6>
          </div>
        </div>

        <div class="row">
          <div class="col">
            {{ 'titles.clausesToIncludeExtra' | transloco }}
          </div>
        </div>

        @if (!generateClauseListResponse && generatingClausesList) {
          <div
            class="col-1 progress-loader non-blocking generating-clauses-status"
            [hidden]="false"
          >
            <div class="spinner-border" role="generating-clauses-status"></div>
          </div>
        } @else if (!!generateClauseListResponse && !!documentStructureData) {
          <!-- } @else if (tempData) { -->
          <div class="document-structure-table-container">
            <table class="document-structure-table">
              <tr>
                <th>
                  @if (canWrite) {
                  <mat-checkbox
                    [checked]="isAllDocumentStructureSelected"
                    [indeterminate]="isDocumentStructureSelectionIndeterminate"
                    (change)="toggleSelectAllDocumentStructure($event.checked)"
                  ></mat-checkbox>
                  }
                </th>
                <th>
                  {{ 'labels.clauseName' | transloco }}
                </th>
                <th>
                  {{ 'labels.source' | transloco }}
                </th>
              </tr>
              @for (item of documentStructureItems; track item.order) {
                <tr>
                  <td>
                    @if (canWrite) {
                    <mat-checkbox
                      [checked]="isDocumentStructureSelected(item)"
                      (change)="toggleDocumentStructureItem(item, $event.checked)"
                    ></mat-checkbox>
                    }
                  </td>
                  <td>
                    {{ item.title }}
                  </td>
                  <td>
                    {{ (item.isSuggested ? 'titles.suggested' : 'titles.playbook') | transloco }}
                  </td>
                </tr>
              }
            </table>
          </div>
        }

        @else if (generateClauseListFailed) {
          <div class="message-generate-clause-list-failure" role="alert">
            <div class="message-generate-clause-list-failure__icon-wrapper">
              <div class="message-generate-clause-list-failure__icon">
                <mat-icon svgIcon="data_alert"></mat-icon>
              </div>
            </div>
            <div class="message-generate-clause-list-failure__content">
              {{ 'errors.generateClauseListFailure' | transloco }}<br /><br />
              {{ 'errors.generateClauseListFailure2' | transloco }}
              <a [href]="'mailto:' + constants.supportEmail">{{ constants.supportEmail }}</a>
            </div>
            <div class="message-generate-clause-list-failure__actions mt-4">
              @if (canWrite) {
              <app-button
                [type]="btnTypes.Flat"
                label="{{ 'buttons.retry' | transloco }}"
                [disabled]="!!generatingClausesList"
                [size]="btnSizes.Basic"
                (onClick)="retryGenerateClauseList()"
              ></app-button>
              }
            </div>
          </div>
        }
      </div>
    }

    @if (currentStep === DocCreateModalSteps.Step1 && !!generatingClausesList) {
      <div
        class="col-1 progress-loader non-blocking generating-clauses-status step1"
        [hidden]="false"
      >
        <div class="spinner-border" role="generating-clauses-status"></div>
      </div>
    }

    @if (
      currentStep === DocCreateModalSteps.Step2 &&
      !!generateClauseListResponse &&
      selectedDocumentStructureCount === 0
    ) {
      <div class="warning-box">
        <div class="left-side">
          <mat-icon>warning</mat-icon>
        </div>
        <div class="right-side">
          <div class="title">
            {{ 'text.noClausesSelected' | transloco }}
          </div>
        </div>
      </div>
    }

    <div class="modal-footer">
      @if (currentStep === DocCreateModalSteps.Step1) {
        @if (canWrite) {
        <app-button
          [type]="btnTypes.Flat"
          label="{{ 'buttons.previewAndCustomize' | transloco }}"
          [disabled]="formStep1.invalid || !!generatingClausesList"
          [size]="btnSizes.Basic"
          (onClick)="previewAndCustomize()"
        ></app-button>

        <app-button
          [type]="btnTypes.Flat"
          label="{{ 'buttons.createNow' | transloco }}"
          [disabled]="formStep1.invalid || !!generatingClausesList"
          [size]="btnSizes.Basic"
          (onClick)="generateOnFirstStep()"
        ></app-button>
        }
      }

      @if (currentStep === DocCreateModalSteps.Step2) {
        <app-button
          *ngIf="canWrite"
          [type]="btnTypes.Flat"
          [icon]="'chevron_left'"
          class="back"
          label="{{ 'buttons.back' | transloco }}"
          [size]="btnSizes.Basic"
          [disabled]="noClausesFound || !!generatingClausesList"
          (onClick)="back()"
        ></app-button>
        <app-button
          [type]="btnTypes.Flat"
          label="{{ 'buttons.createDoc' | transloco }}"
          [size]="btnSizes.Basic"
          [disabled]="
            noClausesFound || !!generatingClausesList || selectedDocumentStructureCount === 0
          "
          (onClick)="createOnStep2()"
        ></app-button>
      }
    </div>
  </div>
}
